import { createContext } from 'react';

const contextTemplate = {};

export const PageContext = createContext({ ...contextTemplate });
export const PageDispatchContext = createContext({ dispatch: () => {} });
export const TakerNotificationContext = createContext({
  openTakerNotification: () => {},
  closeTakerNotification: () => {},
});
